// extracted by mini-css-extract-plugin
export default {"fieldDetailText":"HelpRequestForm_fieldDetailText__Zjx3e","card":"HelpRequestForm_card__0A0xq","buttons":"HelpRequestForm_buttons__PNiPU","spinner":"HelpRequestForm_spinner__5Y0lU"};